<template>
	<div class="person-panel-list" ref="$personPanelList">
		<app-loader v-if="isLoadingAll" :style="loaderStyle"/>
		<div class="person-panel-list__count">
			Найдено контактов:
			<div class="person-panel-list__count-number">{{ clients?.length || 0 }}</div>
		</div>
		<template
			v-for="(client, index) in clients"
			:key="client.Id"
		>
			<clients-panel-list-item
				:client="client"
				:search-text="props.searchText"
			/>
			<div
				v-if="index < clients.length - 1"
				class="person-panel-list__divider"
			/>
		</template>
		<div
			v-if="isLoadingPartial"
			class="person-panel-list__load-partial"
		>
			<app-loader />
		</div>
		<div
			v-if="isScrollBtnVisible"
			class="person-panel-list__scroll-top"
			@click="scrollListTop"
		>
			<app-icon
				class="client-item__footer-options-btn"
				name="arrow-up"
				width="24px"
				color="#fff"
				title="Наверх"

			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import {
	computed,
	onMounted,
	onUnmounted,
	ref,
	watch
} from "vue";
import throttle from "lodash/throttle";
import { clientsStore } from "@/store/clients";
import ClientsPanelListItem from "@/components/main/clients-panel/ClientsPanelListItem.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import { mdiArrowUp } from "@quasar/extras/mdi-v7";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";

const emit = defineEmits<{
	(e: 'on-get-partial'): void,
}>()

const props = defineProps<{
	searchText: string;
}>()

const store = clientsStore()
const $personPanelList = ref<HTMLDivElement | null>(null)
const isScrollBtnVisible = ref(false)

const isLoadingAll = computed(() => store.clientsLoading);
const isLoadingPartial = computed(() => store.clientsPartialLoading);
const clients = computed(() => store.getClients);

const scrollListTop = () => {
	$personPanelList.value?.scrollTo({
		top: 0
	});
}

const onScroll = throttle(() => {
	if (!$personPanelList.value) return

	if ($personPanelList.value.scrollTop + $personPanelList.value.offsetHeight > ($personPanelList.value.scrollHeight - 1000)) {
		if (!isLoadingPartial.value) {
			emit('on-get-partial')
		}
	}

	isScrollBtnVisible.value = $personPanelList.value.scrollTop > 300
}, 50)

onMounted(() => {
	$personPanelList.value?.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
	$personPanelList.value?.removeEventListener('scroll', onScroll)
	onScroll.cancel()
})

watch(isLoadingAll, (newVal) => {
	if (newVal) {
		$personPanelList.value!.scrollTop = 0
	}
})

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

</script>

<style scoped lang="scss">
.person-panel-list {
	display: flex;
	flex-direction: column;
	flex: 1;
	position: relative;
	border-bottom-left-radius: 8px;
	border-bottom-right-radius: 8px;
	overflow: auto;
	background-color: #fff;

	&__count {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 4px;
		font-size: 12px;
		line-height: 18px;
		color: #4D4D4D;
		&-number {
			font-weight: 600;
			margin-left: 4px;
		}
	}

	&__divider {
		border-bottom: 1px solid #F2F2F2;
		margin-left: 8px;
	}

	&__load-partial {
		display: flex;
		position: relative;
		width: 100%;
		min-height: 60px;
	}

	&__scroll-top {
		display: flex;
		align-items: center;
		justify-content: center;
		position: sticky;
		height: 30px;
		min-height: 30px;
		width: 30px;
		min-width: 30px;
		border-radius: 100%;
		bottom: 6px;
		left: calc(100% - 38px);
		background-color: #979797;
		cursor: pointer;
		transition: background-color 0.1s ease-in-out;

		&:hover {
			background-color: #858585;
		}
	}
}
</style>
